export default __webpack_public_path__ + "static/media/Stalker's Boots of Waning Dusk.84f5027e.jpg";